<template>
    <div class="d-flex flex-row">
        <div class="contaner">
            <h1>xx</h1>
            <el-input v-model="password" type="password" placeholder="请输入内容" @blur="savePassword" />
        </div>
    </div>

</template>
<style>
.contaner {
    width: fit-content;
    height: fit-content;
    transform: translate(-50%,-50%);
    position: absolute;
    top: 50%;
    left: 50%;
}
</style>
<script>
import { defineComponent } from 'vue';
export default defineComponent({
    data() {
        return {
            password: ""
        }
    },
    methods: {
        savePassword() {
            localStorage.setItem("tokenAdmin", this.password)
        }
    }
})
</script>